module.exports = __webpack_public_path__ + "96b7ae989dc2055b5db8c07fdebd1c6d.fbx";